/**
 * 导航工具类
 */
export class Navigation {
  /**
   * 在当前窗口打开链接
   * @param url 目标链接
   */
  static open(url: string) {
    if (!url) {
      console.error('必须提供url参数')
      return
    }
    window.location.href = url
  }

  /**
   * 在新窗口打开链接
   * @param url 目标链接
   * @param target 打开方式，默认为新窗口
   */
  static openBlank(url: string, target: '_blank' | '_self' = '_blank') {
    if (!url) {
      console.error('必须提供url参数')
      return
    }
    window.open(url, target)
  }
}
